import React, { useState } from 'react';
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { RotatingLines } from 'react-loader-spinner';
import MediaInfoComponent from '../../../../common/components/common/media-info.component';
import moment from 'moment';


const EwayBill = ({ quoteDetails, mediaFiles, handleFormMediaItemChange, fileTypes, changeImage, isLoading, dropLocations, pickupLocations, quoteData, packageItem, handleBackSteps, handleSteps }: any) => {

    const startLocation = quoteDetails?.result?.Records[0]?.message?.order?.fulfillments[0]?.start?.location?.address
    const endLocation = quoteDetails?.result?.Records[0]?.message?.order?.fulfillments[0]?.end?.location?.address
    const pickupAddress = `${startLocation?.locality},${startLocation?.city},${startLocation?.state}-${startLocation?.area_code},${startLocation?.country}`
    const dropAddress = `${endLocation?.locality},${endLocation?.city},${endLocation?.state}-${endLocation?.area_code},${endLocation?.country}`
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleRightScroll = () => {
        if (currentIndex < packageItem.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    const handleLeftScroll = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1)
        }
    };



    return (
        <div className="flex flex-row justify-center  items-center  h-screen">
            <div className="overflow-auto h-[575px]  bg-white shadow-xl m-3 min-w-[400px]">
                <div className="flex flex-col justify-center items-start p-6 space-y-5">
                    <div className='text-xl font-semibold '>Order Summary</div>
                    <div className="w-full flex items-center justify-between p-2 border-b border-black">
                        <div className="text-lg font-semibold ">
                            Package Details
                        </div>
                        <div className="pl-32">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M19 9l-7 7-7-7"
                                />
                            </svg>
                        </div>
                    </div>

                    <div className="w-full flex items-center justify-between">
                        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 mx-2">
                            <div className="pb-4">
                                <label className="text-md font-semibold block">No of items added</label>
                                <label className="text-base block mt-1">{quoteDetails?.result?.Records[0]?.message?.order?.LinkedItems?.length}</label>
                            </div>
                            <div className="pb-4">
                                <label className="text-md font-semibold block">Service Type</label>
                                <label className="text-base block mt-1">{quoteDetails?.result?.Records[0]?.message?.order?.items[0]?.category_id}</label>
                            </div>
                            <div className="pb-4">
                                <label className="text-md font-semibold block">Relocation Date</label>
                                <label className="text-base block mt-1">
                                    {quoteDetails?.result?.Records[0]?.message?.order ? quoteDetails?.result?.Records[0]?.message?.order?.items[0]?.time?.timestamp : moment().format('YYYY-MM-DD h:mm:ss a')}

                                </label>
                            </div>
                            <div className="pb-4">
                                <label className="text-md font-semibold block">Amount Quoted</label>
                                <label className="text-base block mt-1">₹ {quoteDetails?.result?.Records[0]?.message?.order?.quote?.breakup[0]?.price?.value}</label>
                            </div>
                        </div>


                    </div>
                    <div className="w-full flex items-center justify-between p-2 border-b border-black">
                        <div className="text-lg font-semibold ">
                            Address Details
                        </div>
                        <div className="pl-32">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M19 9l-7 7-7-7"
                                />
                            </svg>
                        </div>
                    </div>
                    <div className="mt-2 grid grid-cols-1 md:grid-cols-1 gap-4">
                        <div className="mb-1 ">
                            <label className="text-md font-semibold block">
                                Pickup Address
                            </label>
                            <label className="text-base block mt-1">
                                {pickupAddress}
                            </label>
                        </div>
                        <div className="mb-1 ">
                            <label className="text-md font-semibold block">
                                Drop Address
                            </label>
                            <label className="text-base block mt-1">
                                {dropAddress}
                            </label>
                        </div>
                        <div className="mb-1 ">
                            <label className="text-lg pr-5 font-semibold">
                                Shipping Option
                            </label>
                            <label className="text-base ">
                                {quoteDetails?.result?.Records[0]?.message?.order?.fulfillments[0]?.type}
                            </label>
                        </div>

                    </div>
                </div>
            </div>
            <div className="overflow-auto bg-white shadow-xl m-3 h-[575px] min-w-[900px]">
                <div className="flex flex-col justify-center items-start p-10 space-y-5">
                    <div className='text-xl font-semibold '>E-Way Bill</div>
                    <div className='text-md font-normal'>Upload the E-Way Bill </div>
                    <div className=' ml-3 w-[800px]'>
                        <MediaInfoComponent
                            changeImage={changeImage}
                            // deleteSelectedProduct={deleteSelectedCategory}
                            fileTypes={fileTypes}
                            //handleClose={handleClose}
                            //handleOpen={handleOpen}
                            onFormItemChange={handleFormMediaItemChange}
                            // openConfirmation={openConfirmation}
                            mediaFiles={mediaFiles}
                        //uploadToDigiiFolder={uploadToDigiiFolder}
                        />
                    </div>

                    <div className='w-full flex justify-end px-10 space-x-3'>
                        <button
                            onClick={handleBackSteps}
                            className='px-4 py-2 bg-primary text-light'>Back</button>
                        <button
                            onClick={handleSteps}
                            disabled={isLoading}
                            className={`${isLoading ? 'bg-primary  bg-opacity-80' : 'bg-primary'} flex items-center justify-center px-4 py-2 text-light`}
                        >
                            Next
                            <div
                                className={`absolute right-4 ${isLoading ? 'visible' : 'invisible'}`}
                            >
                                <RotatingLines
                                    visible={true}
                                    width={'16'}
                                    strokeColor="#fff"
                                    strokeWidth="6"
                                    animationDuration="0.75"
                                    ariaLabel="rotating-lines-loading"
                                />
                            </div>
                        </button>




                    </div>
                </div>
            </div>
        </div >
    );
};

export default EwayBill;
